<div class="layout-footer">
  <div class="footer-start">
    <img [src]="'assets/images/logo-' + (colorScheme === 'light' ? 'dark' : 'light') + '.png'" alt="logo" />
    <!-- No name beside the mark: the copyright line already says "Providence Solutions" (Dan, 2026-10-16). -->
    <a
      class="whats-new-btn"
      href="https://providencesolutions.io/release-notes/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="What's New in the TMS"
      (keydown.space)="$event.preventDefault(); $any($event.target).click()"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2l1.9 5.7L19.6 9.6l-4.6 3.3 1.7 5.8L12 15.4l-4.7 3.3 1.7-5.8-4.6-3.3 5.7-1.9L12 2z" />
      </svg>
      <span>What's New in the TMS</span>
    </a>
  </div>
  <div class="footer-end">
    <span>© {{ currentYear }} Providence Solutions, LLC - All rights reserved, F: {{ frontendVersion }} B: {{ backendVersion }}</span
    ><br />
  </div>
</div>
